<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__bug-watermark"
  >
    <template #pic>
      <icon
        :data="require(!isDark ? '@icon/waterline.svg' : '@icon/waterline.dark.svg')"
        original
        width="var(--icon-24)"
        height="var(--icon-24)"
        class="notification__bug-watermark__icon"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
        class="notification__bug-watermark__title"
      >
        Bug Watermark Exceeded
      </BaseSubHeading>
    </template>
    <template #content>
      <template v-for="key in keys">
        <div
          v-if="content[key]"
          :key="key"
          class="notification__bug-watermark-line"
        >
          <BaseSubHeading
            size="medium"
            color="monochrome-07"
            darkColor="monochrome-03"
            weight="500"
            class="notification__bug-watermark-left"
          >
            <SeverityLevelIcon :level="key.toUpperCase()" />
            {{ key }}
          </BaseSubHeading>
          <div class="notification__bug-watermark-right">
            <BaseSubHeading
              size="medium"
              weight="600"
              class="notification__bug-watermark__current"
              :class="{ 'is-exceeded': content[key].current > content[key].max }"
            >
              {{ content[key].current }}
            </BaseSubHeading>
            <BaseSubHeading
              size="medium"
              color="monochrome-07"
              weight="400"
            >
              of
            </BaseSubHeading>
            <BaseSubHeading
              size="medium"
              weight="600"
              class="notification__bug-watermark__max"
              :class="{ 'is-exceeded': content[key].current > content[key].max }"
            >
              {{ content[key].max }}
            </BaseSubHeading>
          </div>
        </div>
      </template>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useStore } from "vuex"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import SeverityLevelIcon from "@/components/SeverityLevel/SeverityLevelIcon.vue"

import { NotificationBugWatermark } from "@/models/Notification"
import { Getters } from "@/store"

const props = defineProps({
  notification: {
    type: Object as () => NotificationBugWatermark,
    required: true
  }
})

const store = useStore()

const isDark = computed(() => store.getters[Getters.THEME_IS_DARK])
const keys = ["critical", "high", "medium", "trivial"]

const content = computed(() => props.notification.content)
</script>
